__turbopack_context__.v({
  "root": "button-module__Hnuv6G__root",
});
